import React from 'react';
import { useSoftDeleteFormsMenuFormTemplateMutation } from 'shared/types/graphql';
import useForms from 'pages/Forms/hooks/useForms';
import { useCustomToast } from 'shared/hooks/useCustomToast';
import {
  CModal,
  ModalOverlay,
  ModalContent,
  CModalHeader,
  CModalFooter,
  CModalBody,
  ModalCloseButton,
  Text,
  Button,
  Flex,
} from '@televet/kibble-ui';

interface IKeepNewFormModal {
  isOpen: boolean;
  onClose: () => void;
  formTemplateId: string;
  onConfirm: () => void;
}

const KeepNewFormModal = ({ isOpen, onClose, formTemplateId, onConfirm }: IKeepNewFormModal): JSX.Element | null => {
  const [deleteFormTemplate] = useSoftDeleteFormsMenuFormTemplateMutation();
  const { getFormTemplates } = useForms();
  const { toastMessagePop } = useCustomToast();

  const onDeleteForm = async (): Promise<void> => {
    await deleteFormTemplate({ variables: { where: { id: formTemplateId } } });
    toastMessagePop('Form Deleted');
    await getFormTemplates();
    onConfirm();
  };

  return (
    <CModal size="md" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <CModalHeader fontSize="3xl" pb={1}>
          Keep New Form?
        </CModalHeader>
        <ModalCloseButton />
        <CModalBody>
          <Text>
            We noticed you created a new form, but didn&apos;t make any changes to it. Would you like to delete the
            form, or keep it?
          </Text>
        </CModalBody>
        <CModalFooter justifyContent="space-between">
          <Button variant="tertiary" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Flex gap={3}>
            <Button variant="primaryDestructive" onClick={onDeleteForm}>
              Delete
            </Button>
            <Button onClick={onConfirm}>Keep</Button>
          </Flex>
        </CModalFooter>
      </ModalContent>
    </CModal>
  );
};

export default KeepNewFormModal;
